<template>
  <div>
    <v-row class="mt-3">
      <v-col
        v-for="capability in diagnosticStats.capabilities"
        :key="capability.capability_id"
        cols="6"
      >
        <player-diagnostic-group-widget
          :variables="diagnosticStats.variables"
          :capability="capability"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PlayerDiagnosticGroupWidget from '@/components/players/PlayerDiagnosticGroupWidget.vue'

export default {
  name: 'PlayerDiagnosticGraphs',
  components: { PlayerDiagnosticGroupWidget },
  props: {
    diagnosticStats: {
      type: Object,
      required: true
    }
  },
  data: () => ({
  }),
  computed: {

  },
  methods: {
    filterVariablesByCapability(variables, capability) {
      return this.diagnosticStats.variables.filter(variable => variable.capability_id === capability.capability_id)
    }
  }
}
</script>
